import VMPGenericChip from './VMPGenericChip';

export default VMPGenericChip;
export { VMPGenericChip };
